/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../shared/components/Localized';
import { StatusIcon } from '../SVGIcon';
import styled from 'styled-components';

import styles from '../../styles';

const Wrapper = styled.div`
  background-color: #FAFAF9;
  border: 1px solid #F3F2F2;
  display: flex;
  align-items: center;

  height: 40px;
  padding: 0 1rem;
  border-radius: 0.25rem;
`;

const Item = styled.div`
  font-size: .75rem;
  color: #3E3E3C;
  vertical-align: middle;
  margin-right: 1.5rem;
  &.last {
    margin-right: 0;
  }
`;

const StatusIconWithPadding = styled(StatusIcon)`
  margin-right: 0.5rem;
`;

export class StatusKey extends React.Component {
  render() {
    return (
      <Wrapper className={this.props.className}>
        <Item>
          <StatusIconWithPadding size='1rem' severity='healthy' />
          <Localized modelName={'statusKey'} modelKey={'available'} modelAttribute={'label'} />
        </Item>
        <Item>
          <StatusIconWithPadding size='1rem' severity='minor' />
          <Localized modelName={'statusKey'} modelKey={'degradation'} modelAttribute={'label'} />
        </Item>
        <Item>
          <StatusIconWithPadding size='1rem' severity='major' />
          <Localized modelName={'statusKey'} modelKey={'disruption'} modelAttribute={'label'} />
        </Item>
        <Item className="last">
          <StatusIconWithPadding size='1rem' severity='maintenance' />
          <Localized modelName={'statusKey'} modelKey={'maintenance'} modelAttribute={'label'} />
        </Item>
      </Wrapper>
    );
  }
}


